'use client';

import type { ExhibitionGridItemType } from './types';
import { useState, type FC } from 'react';
import { cn, ERROR_IMAGE_URL, ProductBadge } from '@yanolja-rnd/nol-design-system';
import { BaseImage } from '@/app/_components/common/base-image';

interface ExhibitionGridItemProps {
  item: ExhibitionGridItemType;
  type: 'widget' | 'page';
  onClick?: () => void;
}

const ExhibitionGridItem: FC<ExhibitionGridItemProps> = ({ item, type, onClick }) => {
  const { title, subtitle, badge, representative } = item;
  const { domain, path, filename } = representative;

  const [isImageError, setIsImageError] = useState(false);

  return (
    <div className="cursor-pointer" onClick={onClick}>
      {/* 모바일 뷰 */}
      <div
        className={cn('relative overflow-hidden pc:rounded-16', {
          'overflow-visible rounded-none pc:overflow-hidden': type === 'page',
        })}>
        <div className="relative aspect-square">
          <BaseImage
            src={isImageError ? ERROR_IMAGE_URL : `${domain}${path}${filename}`}
            alt=""
            className="object-cover"
            onError={() => {
              setIsImageError(true);
            }}
          />

          <div className="absolute inset-0 bg-opacity-black-30" />
        </div>

        {!!badge.title && (
          <div
            className="absolute left-8 top-8 rounded-6 pc:left-12 pc:top-12"
            style={{ backgroundColor: badge.bgColor }}>
            <ProductBadge size={{ pc: 'large', mobile: 'medium' }} type="filled_whiteop">
              {badge.title}
            </ProductBadge>
          </div>
        )}

        <div className="absolute bottom-0 flex w-full flex-col gap-4 px-16 pb-16 text-static-white pc:gap-16 pc:px-32 pc:pb-40">
          <div className="typography-subtitle-18-bold-line-clamp-2 pc:typography-headline-32-bold-line-clamp-2">
            {title}
          </div>
          {!!subtitle && (
            <p className="typography-caption-11-regular-line-clamp-1 pc:typography-subtitle-20-regular-line-clamp-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExhibitionGridItem;
